import { validateEmail } from '../validateEmail';

export const emailValidator = (email: string): string | undefined => {
	if (email === '') return 'Email is required.';

	if (validateEmail(email)) return;

	return 'Invalid email address.';
};
